import React, { useEffect, useState } from 'react'
import { database } from '../Firebase/firebase';
import { firebaseCollections } from '../Constants/Variables';
import AppRoutes from '../AppRoutes';

import AppSpinner from '../Components/AppSpinner';

export default function LoadingData(props) {

    const [user, setUser] = useState(null)

    var provider = props.provider;
    var account = provider.account;
    
    useEffect(() => {

        //GET Current User Data
        var docRef = database.collection(firebaseCollections.users).doc(account.accountIdentifier);
        docRef.get().then((doc) => {
            if (doc.exists) {
                setUser(doc.data());
            } else {
                console.log("No such user");
                var newUserRef = database.collection(firebaseCollections.users).doc(account.accountIdentifier);
                var newUserObj = {
                    uid: account.accountIdentifier,
                    email: account.userName,
                    name: account.name,
                    role: "Associate"
                };
                newUserRef.set(newUserObj, { merge: true }).then(() => {
                    setUser(newUserObj);
                });
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

        return () => {

        }
    }, [])


    return user ? (<AppRoutes provider={provider} fbaccount={user} />) : <AppSpinner fullHeight={true} loadingtext="JUST A SEC..." />
}
